import CreateWorkspacePage from './CreateWorkspacePage'

export default CreateWorkspacePage
